"use client";

import { useEffect, useState } from "react";
import { Book, Beaker, Lightbulb, Target } from "lucide-react";

export default function IITJam() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const topics = [
    {
      title: "Basic Chemistry",
      description:
        "Covering all the fundamental concepts of Chemistry comprehensively",
      icon: Target,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "Organic Chemistry",
      description:
        "Master reaction mechanisms, synthesis strategies, and named reactions with detailed problem-solving approaches",
      icon: Beaker,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "Inorganic Chemistry",
      description:
        " A detailed exploration of fundamental and advanced topics in Inorganic Chemistry",
      icon: Book,
      color: "from-blue-500 to-blue-600",
    },
    {
      title: "Physical Chemistry",
      description:
        "Comprehensive coverage of thermodynamics, kinetics, electrochemistry, and quantum mechanics",
      icon: Lightbulb,
      color: "from-blue-500 to-blue-600",
    },
  ];

  return (
    <section id="iit-jam" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#162456]">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center mb-16 ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white text-pretty">
            IIT JAM{" "}
            <span className="text-[var(--secondary-color)]">Chemistry</span>{" "}
            Syllabus
          </h2>
          <p className="text-lg text-[#d1d1d1] max-w-2xl mx-auto">
            Comprehensive coverage of all chemistry topics for IIT JAM exam with
            expert guidance
          </p>
        </div>

        {/* Topics Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {topics.map((topic, index) => {
            const Icon = topic.icon;
            return (
              <div
                key={index}
                className={`group ${
                  isVisible ? "animate-fade-in-up" : "opacity-0"
                }`}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="h-full bg-[var(--secondary-color)] rounded-xl p-8 border border-blue-600/30 hover:border-yellow-400/50 transition-all duration-300 hover:shadow-2xl hover:shadow-yellow-400/20">
                  <div
                    className={`inline-block p-3 rounded-lg bg-gradient-to-br ${topic.color} mb-4`}
                  >
                    <Icon size={32} className="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-black mb-3">
                    {topic.title}
                  </h3>
                  <p className="text-[#393939] leading-relaxed">
                    {topic.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div
          className={`mt-16 p-8 bg-gradient-to-r from-yellow-400/10 to-blue-400/10 rounded-xl border border-yellow-400/30 text-center ${
            isVisible ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <p className="text-xl text-[#d1d1d1]">
            Join the latest Batch at <b className="text-yellow-200">2999</b>{" "}
            INR. Limited Seats Available!{" "}
            <button className="bg-[var(--secondary-color)] hover:bg-yellow-300 text-black font-semibold px-6 py-2 rounded-full transition duration-300">
              Enroll Now
            </button>
          </p>
        </div>
      </div>
    </section>
  );
}
